export function getDataLocalStorage(key, defaultValue = null) {
  if (typeof window === "undefined") {
    return defaultValue
  }

  try {
    const item = window.localStorage.getItem(key)

    if (!item) return defaultValue

    return JSON.parse(item)
  } catch (error) {
    console.warn(`Ошибка чтения localStorage ключа "${key}":`, error)
    try {
      window.localStorage.removeItem(key)
    } catch (removeError) {}
    return defaultValue
  }
}
